module.exports = __webpack_public_path__ + "static/img/1.5fcc941.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news27/1.png
// module id = XeNR
// module chunks = 1